import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalHeader = props => {

    const {
        closeAllModals = false,
        hideCloseIcon = undefined,
        hideModal,
        hideAllModals = undefined,
        hideModalCallback = undefined,
        modalId,
        modalHeaderTextData,
        primaryTopAnchor
    } = props;

    const getHeaderText = () => {

        const getFormattedMessage = () => {
            if(Array.isArray(modalHeaderTextData)) {
                const [ id, replacements ] = modalHeaderTextData;
                return (
                    <FormattedMessage
                        id={id}
                        values={replacements}
                    />
                );
            } else {
                return <FormattedMessage id={ modalHeaderTextData }/>;
            }
        };

        return getFormattedMessage();
    };

    const getHideAction = () => {
        return hideModalCallback ?
            e => {
                e.preventDefault();
                hideModalCallback();
                hideModal();
            } :
            e => {
                e.preventDefault();
                if(closeAllModals) {
                    hideAllModals();
                } else {
                    hideModal();
                }
            };
    };

    return (
        <div className="gi-modal__header" id={ modalId }>
            <h3 tabIndex="-1" id={`${modalId}_heading`} {...(hideCloseIcon && { ref: primaryTopAnchor })}>
                { modalHeaderTextData ? getHeaderText() : null }
            </h3>
            { 
                !hideCloseIcon &&

                <div className="gi-modal__btn--close">
                    <a
                        id={`${modalId}-close-button-icon`}
                        href="#"
                        onClick={getHideAction()}
                        ref={ primaryTopAnchor }
                        aria-label="Close"
                    >
                        <FontAwesomeIcon icon="times"/>
                    </a>
                </div>
            }
        </div>
    );
};

export default ModalHeader;
